import { Injectable } from "@angular/core";
import { AccountHandlerService } from "../handlers/account-handler.service";
import { AccountDTO } from "./Account";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  constructor(private AccountHandlerService: AccountHandlerService) {}

  getAccount(
    accountMasterID: number,
    accountID: number,
    ignoreAccountUsers?: boolean,
  ) {
    return this.AccountHandlerService.getAccount(
      accountMasterID,
      accountID,
      ignoreAccountUsers,
    );
  }

  deleteAccount(
    accountMasterID: number,
    accountID: number,
    ignoreAccountUsers?: boolean,
  ) {
    return this.AccountHandlerService.deleteAccount(
      accountMasterID,
      accountID,
      ignoreAccountUsers,
    );
  }

  getAccounts(
    accountMasterID: number,
    queryParams?: {
      facility_id?: number[];
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
      ignoreAccountUsers?: boolean;
    },
  ) {
    return this.AccountHandlerService.getAccounts(accountMasterID, queryParams);
  }

  updateAccount(
    accountMasterID: number,
    accountDTO: AccountDTO,
    ignoreAccountUsers?: boolean,
  ) {
    return this.AccountHandlerService.putAccount(
      accountMasterID,
      accountDTO,
      ignoreAccountUsers,
    );
  }

  updateAccountCatalog(accountMasterID: number, accountDTO: AccountDTO) {
    return this.AccountHandlerService.putAccountCatalog(
      accountMasterID,
      accountDTO,
    );
  }

  createAccount(accountMasterID: number, accountDTO: AccountDTO) {
    return this.AccountHandlerService.postAccount(accountMasterID, accountDTO);
  }

  getStripeCustomerSession(accountMasterID: number, stripeId: string) {
    return this.AccountHandlerService.getStripeSession(accountMasterID, stripeId);
  }

  createStripeCustomer(accountId: number, stripeID: string, stripeName: string) {
    return this.AccountHandlerService.postStripeCustomer(accountId, stripeID, stripeName);
  }

  deleteStripeCustomer(customer: any) {
    return this.AccountHandlerService.deleteStripeCustomer(customer.account_id, customer.id);
  }

}
